export default __webpack_public_path__ + "static/media/cs_icon_04.ccba497f.png";